import classnames from 'classnames';
import { ChipProps } from './types';
import s from './index.module.scss';

export const Chip = ({ selected = false, size = 'medium', children, className,...nativeButtonProps }: ChipProps) => {
  return (
    <button
      type="button"
      className={classnames(s.chip, selected && s.chip_selected, `size_${size}`, className)}
      {...nativeButtonProps}
    >
      {children}
    </button>
  );
};